import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';
import qs from 'qs';
Vue.use(Router);

const router = new Router({
    mode: 'history',
    //mode: 'hash', //pq funcioni el mode app
    base: process.env.BASE_URL,
    linkActiveClass: 'is-active',
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return {
                selector: to.hash,
                behavior: 'smooth',
            };
        }
        return { x: 0, y: 0 };
    },
    stringifyQuery: (query) => {
        const result = qs.stringify(query, { format: 'RFC1738' });
        return result ? '?' + result : '';
    },
    routes: [
        {
            path: '/',
            name: 'home_login',
            props: (route) => route.query,
            meta: { requiresAnonymous: true },
            component: () =>
                import(/* webpackChunkName: "login" */ './views/LoginPage.vue'),
        },
        /*{
            path: '/privacy',
            name: 'privacy',
            component: () =>
                import( './views/Privacy.vue'),
        },
        {
            path: '/tos',
            name: 'tos',
            component: () =>
                import( './views/TOS.vue'),
        },*/
        {
            path: '/login/auth_callback',
            name: 'login',
            props: (route) => route.query,
            component: () =>
                import('./views/Login.vue'),
        },
        {
            path: '/login/auth_callback_microsoft',
            name: 'login_microsoft',
            component: () =>
                import(
                    './views/LoginMicrosoft.vue'
                ),
        },
        {
            path: '/dashboard',

            meta: { requiresAuth: true, denyVicensUsers: true },
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "dashboard" */ './views/Dashboard.vue'
                    ),
            },
            children: [
                {
                    path: '',
                    name: 'dashboard',
                    meta: { requiresAuth: true },
                    components: {
                        default: () =>
                            import('./components/DashboardProjects.vue'),
                    },
                },
                {
                    path: 'import',
                    name: 'import',
                    props: { default: true },
                    meta: { requiresAuth: true },
                    component: () =>
                        import(
                            /* webpackChunkName: "import" */
                            './components/DashboardImport.vue'
                        ),
                },
                {
                    name: 'dashboard-folder',
                    path: 'folder/:folder([a-fA-F0-9]{24})',
                    meta: { requiresAuth: true },
                    props: { default: true },
                    component: () =>
                        import(
                            /* webpackChunkName: "folder" */
                            './components/DashboardFolderContent.vue'
                        ),
                },
                {
                    name: 'dashboard-user',
                    path: 'user',
                    meta: { requiresAuth: true },
                    props: { default: true },
                    component: () =>
                        import(
                            /* webpackChunkName: "user" */
                            './components/DashboardUser.vue'
                        ),
                },
                // Gestió del plà de pagament de l'usuari
                /*{
                    name: 'dashboard-user-plan',
                    path: 'user/subscription',
                    meta: { requiresAuth: true },
                    props: { default: true },
                    component: () =>
                        import(
                            './components/DashboardUserPlan.vue'
                        ),
                },*/
                // Gestió del llistat app de l'usuari
                /*{
                    path: 'appContent',
                    name: 'userAppContent',
                    meta: { requiresAuth: true },
                    props: { default: true },
                    component: () =>
                        import(
                            './components/DashboardAppContent.vue'
                        ),
                },*/
            ],
        },

        {
            path: '/management',

            meta: { requiresAuth: true },
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "management" */ './views/Management.vue'
                    ),
            },
            children: [
                {
                    path: '',
                    name: 'entityProjects',
                    meta: { requiresAuth: true },
                    components: {
                        default: () =>
                            import('./components/ManagementEntityProjects.vue'),
                    },
                },
                {
                    path: '/management/users',
                    name: 'entityUsers',
                    meta: { requiresAuth: true },
                    props: { default: true },
                    component: () =>
                        import(
                            /* webpackChunkName: "users" */
                            './components/DashboardUsers.vue'
                        ),
                },
                {
                    path: '/management/appContent',
                    name: 'entityAppContent',
                    meta: { requiresAuth: true },
                    props: { default: true },
                    component: () =>
                        import(
                            /* webpackChunkName: "appContent" */
                            './components/DashboardAppContent.vue'
                        ),
                },
                {
                    path: '/management/stats',
                    name: 'entityStats',
                    meta: { requiresAuth: true },
                    props: { default: true },
                    component: () =>
                        import(
                            './components/ManagementEntityStats.vue'
                        ),
                },
            ],
        },

        /*{
            path: '/explore',
            name: 'explorer',
            components: {
                default: () =>
                    import(
                       './views/Explorer.vue'
                    ),
            },
        },*/
        {
            path: '/creation',
            name: 'creation',
            meta: { requiresAuth: true },
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "creation" */ './views/Creation.vue'
                    ),
            },
        },
        {
            path: '/project/:projectId([a-fA-F0-9]{24})',
            name: 'project',
            props: { default: true },
            meta: { layout: 'project' },
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "project" */ './views/Project.vue'
                    ),
            },
            children: [
                {
                    path: ':objectId([a-fA-F0-9]{24})',
                    name: 'object-detail',
                    meta: { layout: 'project' },
                    props: { default: true },
                    components: {
                        default: () =>
                            import(
                                /* webpackChunkName: "object-detail" */
                                './components/ProjectContentModalView.vue'
                            ),
                    },
                },
            ],
        },
        {
            path: '/embed/project/:projectId([a-fA-F0-9]{24})',
            name: 'embed-project',
            props: { default: true },
            meta: { layout: 'project', hideLogin: true, embed: true },
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "project-embed" */
                        './views/Project.vue'
                    ),
            },
            children: [
                {
                    path: ':objectId([a-fA-F0-9]{24})',
                    name: 'embed-object-detail',
                    meta: { layout: 'project', embed: true },
                    props: { default: true },
                    components: {
                        default: () =>
                            import(
                                /* webpackChunkName: "object-detail" */
                                './components/ProjectContentModalView.vue'
                            ),
                    },
                },
            ],
        },
        {
            path: '/share/project/:projectId([a-fA-F0-9]{24})',
            name: 'share-project',
            props: { default: true },
            meta: { layout: 'Share', hideLogin: true },
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "project-shared" */
                        './views/ShareProject.vue'
                    ),
            },
        },
        {
            path: '/session/:_id([a-fA-F0-9]{24})',
            name: 'session-detail',
            props: { default: true },
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "session-detail" */
                        './views/SessionDetail.vue'
                    ),
            },
        },
        {
            path: '/project/:projectId([a-fA-F0-9]{24})/view',
            name: 'project-view',
            props: { default: true },
            meta: { layout: 'embed-view' },
            components: {
                default: () =>
                    import(
                        /* webpackChunkName: "project" */ './views/projectView.vue'
                    ),
            },
        },
    ],
});

router.beforeEach((to, from, next) => {
    // console.log('beforeEach route', to, store.getters.isLoggedIn, store.getters.isAnonymous)
    if (
        (!store.getters.isLoggedIn || store.getters.isAnonymous) &&
        to.name != 'login' &&
        to.name != 'home' &&
        to.name != 'login_microsoft' &&
        to.fullPath != '/'
    ) {
        // console.log('saving currentUri in first if', to.fullPath);
        localStorage.setItem('currentUri', to.fullPath);
    }

    if (to.name == 'dashboard' && store.getters.isAnonymous) {
        // console.log('saving currentUri in first if', to.fullPath);
        // console.log("anonymous user try to access to dashboard")
        store.dispatch('logout');
    }
    // Vue.prototype.$Progress.start();
    /*if (to.query.lb && to.name != 'login') {
        if (to.query.embed == "true") {
            store.commit('SET_RENDER_NAVBAR', false);
        }
        if (store.getters.isLoggedIn) {
            store.dispatch('logout');
        }
        // console.log('saving currentUri in second if', to.path);
        localStorage.setItem('currentUri', to.path);
        return next({
            name: 'login',
            query: to.query,
        });
    }*/
    /*if (!store.getters.isLoggedIn && !to.query.lb) {
        store.dispatch('anonymousLogin');
    }*/
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!store.getters.isLoggedIn) {
            // console.log('not logged in returning');
            return next({
                path: '/',
            });
        } else {
            return next();
        }
    } else if (to.matched.some((record) => record.meta.requiresAnonymous)) {
        // this route requires no auth, check if logged in
        //return next();
        if (store.getters.isLoggedIn && to.name == 'home_login') {
            if (store.getters.user.entities) {
                // console.log("checking entities permissions")
                store.getters.user.entities.forEach(element => {

                    if ((element.entity._id == store.getters.user.school._id) && (element.permission != 'GUEST')) {
                        // console.log("no creation")
                        return next({
                            name: 'dashboard',
                            query: {
                                filter: 'mine',
                            },
                        });
                    } /*else {
                        // console.log("can create")
                        canCreate=true
                    }*/
                });
            }
            return next({
                name: 'dashboard',
                query: {
                    filter: 'access',
                },
            });
        } else {
            return next();
        }
    } else {
        return next(); // make sure to always call next()!
    }
});

router.afterEach(() => {
    // Vue.prototype.$Progress.finish();
});

router.onError((error) => {
    if (/loading chunk \d* failed./i.test(error.message)) {
        console.warn('reloading because of chunk failed');
        window.location.reload();
    }
});

export default router;
